import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	opacity: 0;
	transition: opacity 0.3s ease;
`;

const StyledShadow = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background-color: #111314;
	opacity: 0.75;
`;

export { StyledContainer, StyledShadow };
